export const AboutMe = () => {
  return (
    <div className='bg-[#397D8D70] backdrop-blur py-16 px-4 sm:px-6 lg:px-8 text-white' id='aboutme'>
      <div className='max-w-3xl mx-auto flex flex-col gap-4'>
        <h2 className='text-3xl font-extrabold sm:text-4xl'>
          Acerca de mí
        </h2>
        <div>
          <p className='text-lg'>
            Soy Merling Samuel Sobalvarro Reyes, un desarrollador de aplicaciones apasionado por la programación.
          </p>

          <p className='mt-4 text-lg'>
            Soy Full Stack Javascript con más de 7 años de experiencia en desarrollo de aplicaciones web y móviles, así como en diseño y consultoría de datos. Mi stack técnico incluye principalmente React y Nodejs. Mi objetivo es aplicar mis habilidades en proyectos desafiantes en la industria digital, destacando mi liderazgo, comunicación y atención al detalle para lograr un crecimiento continuo.
          </p>

          <p className='mt-4 text-lg'>
            He participado en diferentes proyectos como el desarrollo de oficinas virtuales, plataformas de administración, plataformas de datos, y muchos más.
          </p>
        </div>
      </div>
    </div>
  )
}
